import React from "react";
import PATHS from "config/paths";

/* eslint-disable react-hooks/exhaustive-deps */

const cache = new Map();

export default function useDeleteEvent(token, id) {
  const [error, setError] = React.useState();
  const [isDeleteComplete, setIsDeleteComplete] = React.useState(false);

  React.useEffect(() => {
    if (token && id) {        
        setError(undefined);

        const headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", `Bearer ${token}`);
        headers.append("Origin", "{location.protocol + '//' + location.host}");
        const options = {
          method: "DELETE",
          headers: headers,
          redirect: "follow",
          cache: "no-cache",
        };

        /**
         * Make request
         */
        fetch(`${PATHS.apiEvents}/${id}`, options)
          .then((response) => {
            return response.json();
          })
          .catch((error) => setError(error))
          .finally(() => {
            setIsDeleteComplete(true);
          });
        }
    
  }, [token, id]);

  return { isDeleteComplete, eventsError: error };
}
